import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function ShowroomPage() {
  return (
    <div className="min-w-[1024px]">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-44 pb-20 bg-dark overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/bafe38a9debe738ee04c4070b2eadd4e.jpg"
              alt="Eclectic Home Furniture Showroom Las Vegas"
              className="w-full h-full object-cover object-center opacity-50"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-dark/80 to-dark/40" />
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-6">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-8 h-px bg-gold" />
              <span className="text-gold text-xs font-semibold uppercase tracking-[0.25em]">Come See Us</span>
            </div>
            <h1 className="font-serif text-6xl font-bold text-white mb-5">Visit Our Showroom</h1>
            <p className="text-white/60 text-lg max-w-xl">
              Experience 500+ curated furniture pieces in person. Our Las Vegas showroom is designed 
              to inspire — and our design team is here to help.
            </p>
          </div>
        </section>

        {/* Showroom Info + Map */}
        <section className="py-24 bg-cream-DEFAULT">
          <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-14">
            <div>
              <div className="flex items-center gap-3 mb-6">
                <span className="w-8 h-px bg-gold" />
                <span className="text-gold text-xs font-semibold uppercase tracking-[0.25em]">Plan Your Visit</span>
              </div>
              <h2 className="font-serif text-4xl font-bold text-dark mb-8">
                Las Vegas<br /><span className="text-gold">Flagship Showroom</span>
              </h2>

              <div className="space-y-6 mb-10">
                {[
                  { icon: 'ri-map-pin-fill', label: 'Address', val: '3750 S Las Vegas Blvd, Las Vegas, NV 89158' },
                  { icon: 'ri-phone-fill', label: 'Phone', val: '(702) 850-9900' },
                  { icon: 'ri-mail-fill', label: 'Email', val: 'hello@eclectichome.com' },
                ].map((c) => (
                  <div key={c.label} className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gold/10 flex-shrink-0">
                      <i className={`${c.icon} text-gold`} />
                    </div>
                    <div>
                      <span className="block text-[10px] text-dark/40 font-semibold uppercase tracking-wider mb-1">{c.label}</span>
                      <span className="text-dark font-semibold text-sm">{c.val}</span>
                    </div>
                  </div>
                ))}
              </div>

              <h3 className="font-serif text-xl font-bold text-dark mb-5">Showroom Hours</h3>
              <div className="space-y-3 mb-10">
                {[
                  { day: 'Monday – Friday', time: '10:00 AM – 7:00 PM' },
                  { day: 'Saturday', time: '10:00 AM – 6:00 PM' },
                  { day: 'Sunday', time: '11:00 AM – 5:00 PM' },
                ].map((h) => (
                  <div key={h.day} className="flex justify-between py-3 border-b border-cream-dark">
                    <span className="text-dark/60 text-sm">{h.day}</span>
                    <span className="text-dark font-semibold text-sm">{h.time}</span>
                  </div>
                ))}
              </div>

              <div className="bg-dark rounded-xl p-6">
                <h4 className="font-serif text-lg font-bold text-white mb-3">Book a Design Consultation</h4>
                <p className="text-white/50 text-sm mb-5">
                  Schedule a private session with one of our certified interior designers. Free, no obligation.
                </p>
                <Link to="/contact" className="inline-flex items-center gap-2 bg-gold text-white px-6 py-3 rounded text-xs font-bold uppercase tracking-wider cursor-pointer whitespace-nowrap hover:bg-gold-dark transition-colors">
                  Book Now <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>

            <div>
              <div className="w-full h-96 rounded-2xl overflow-hidden border border-cream-dark mb-6">
                <iframe
                  title="Eclectic Home Furniture Showroom Las Vegas"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3221.0!2d-115.1719!3d36.1069!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80beb782a4f57dd1%3A0x3accd5e6d5b379a3!2sLas%20Vegas%20Strip%2C%20Las%20Vegas%2C%20NV!5e0!3m2!1sen!2sus!4v1"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                {[
                  { val: '10,000 sq ft', label: 'Showroom Space' },
                  { val: '500+', label: 'Pieces on Display' },
                  { val: 'Free', label: 'Design Consult' },
                  { val: 'Same-Day', label: 'Quoting' },
                ].map((s) => (
                  <div key={s.label} className="bg-white border border-cream-dark rounded-xl p-5">
                    <div className="font-serif text-3xl font-bold text-dark mb-1">{s.val}</div>
                    <div className="text-dark/40 text-xs uppercase tracking-wider">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Showroom Photos */}
        <section className="py-16 bg-cream-mid">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="font-serif text-3xl font-bold text-dark mb-8 text-center">Inside Our Showroom</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {[
                { src: 'https://readdy.ai/api/search-image?query=luxury%20furniture%20showroom%20interior%20living%20room%20display%20area%20warm%20amber%20lighting%20premium%20sofas%20chairs%20sophisticated%20retail%20atmosphere%20high-end%20photography&width=700&height=500&seq=sr1&orientation=landscape', alt: 'Living room showroom display' },
                { src: 'https://readdy.ai/api/search-image?query=elegant%20bedroom%20furniture%20showroom%20display%20area%20beds%20nightstands%20dressers%20warm%20lighting%20sophisticated%20interior%20retail%20Las%20Vegas&width=700&height=500&seq=sr2&orientation=landscape', alt: 'Bedroom showroom display' },
                { src: 'https://readdy.ai/api/search-image?query=premium%20dining%20room%20furniture%20showroom%20display%20tables%20chairs%20chandelier%20warm%20atmospheric%20lighting%20sophisticated%20retail%20environment&width=700&height=500&seq=sr3&orientation=landscape', alt: 'Dining room showroom display' },
              ].map((img) => (
                <div key={img.src} className="rounded-xl overflow-hidden h-56">
                  <img src={img.src} alt={img.alt} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
